import { useAsertoApi } from '@aserto/console-common'
import { useMutation } from '@tanstack/react-query'

import { Configurations } from '../../common/types'
import { useClientConfig } from '../services/EnvConfigProvider'
import { ReactQueryMutationHooks } from '../types/local/general'

export const useTopazLogin = (
  mutationHooks: ReactQueryMutationHooks<Configurations, { apiKey: string }> = {}
) => {
  const { discoveryServiceUrl } = useClientConfig()
  const { get } = useAsertoApi(discoveryServiceUrl)

  return useMutation(
    ['login'],
    (body) =>
      get({ path: `api/v2/config`, headerOverrides: { authorization: `Basic ${body.apiKey}` } }),
    mutationHooks
  )
}
